

// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import { motion, AnimatePresence } from 'framer-motion';

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [servicesDropdown, setServicesDropdown] = useState(false);
//   const [activeServiceCategory, setActiveServiceCategory] = useState(null);
//   const [mobileServiceExpanded, setMobileServiceExpanded] = useState(null);
//   const location = useLocation();

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     setMobileMenuOpen(false);
//     setServicesDropdown(false);
//     setActiveServiceCategory(null);
//   }, [location]);

//   const serviceCategories = [
//     {
//       name: 'Patient Growth & Visibility',
//       path: '/services/growth-visibility',
//       subServices: [
//         'SEO for Doctors',
//         'Local SEO (Clinic Area Targeting)',
//         'Google My Business (GMB) Management',
//         'Multi-Location Clinic SEO',
//         'Medical Directory Listings',
//         'Online Reputation Management',
//         'Review & Rating Growth'
//       ]
//     },
//     {
//       name: 'Ads & Patient Acquisition',
//       path: '/services/marketing-client-acquisition',
//       subServices: [
//         'Google Ads for Doctors',
//         'Meta Ads (Facebook & Instagram)',
//         'LinkedIn Ads (Hospitals & Groups)',
//         'Patient Lead Generation',
//         'Funnel & Retargeting Setup',
//         'Ad Monitoring & Optimization'
//       ]
//     },
//     {
//       name: 'Social Media & Branding',
//       path: '/services/social-media-branding',
//       subServices: [
//         'Social Media Management',
//         'Content Planning & Posting',
//         'Instagram, Facebook & LinkedIn',
//         'Comment & DM Management',
//         'Influencer & Medical Outreach',
//         'Doctor Brand Building'
//       ]
//     },
//     {
//       name: 'Lead Management & Virtual Assistants',
//       path: '/services/meta-virtual-assistant',
//       subServices: [
//         'Lead Management System',
//         'CRM Setup & Automation',
//         'Appointment Booking Support',
//         'Patient Follow-Ups',
//         'Meta Ads Virtual Assistant',
//         'Customer Support Assistance'
//       ]
//     },
//     {
//       name: 'Patient Communication & Analytics',
//       path: '/services/patient-communication-analytics',
//       subServices: [
//         'Email Marketing for Clinics',
//         'WhatsApp Patient Campaigns',
//         'Automated Appointment Reminders',
//         'Performance Reports',
//         'Conversion & ROI Analytics'
//       ]
//     },
//     {
//       name: 'Websites, Apps & Technology',
//       path: '/services/digital-platforms-experience',
//       subServices: [
//         'Domain Purchase & Management',
//         'Doctor & Clinic Website Development',
//         'Website Redesign & Revamp',
//         'Conversion-Focused Design',
//         'Website Speed Optimization',
//         'Website Security & Maintenance',
//         'App Development for Clinics'
//       ]
//     },
//     {
//       name: 'Creative, Media & Content',
//       path: '/services/creative-media-branding',
//       subServices: [
//         'Brand Identity & Logo Design',
//         'Social Media Creatives',
//         'Ad Creatives & Banners',
//         'Video Editing',
//         'Motion Graphics',
//         'Pitch Decks & Brochures'
//       ]
//     },
//     {
//       name: 'Systems, Compliance & Consulting',
//       path: '/services/systems-automation-consulting',
//       subServices: [
//         'Analytics Dashboards',
//         'CRM & Marketing Automation',
//         'Backup & Data Protection',
//         'Compliance & Website Security',
//         'Clinic Growth Consulting',
//         'Digital Strategy Consulting'
//       ]
//     }
//   ];

//   const navLinks = [
//     { name: 'Home', path: '/' },
//     { name: 'About Us', path: '/about' },
//     { name: 'Services', path: '/services', hasDropdown: true },
//     { name: 'Portfolio', path: '/portfolio' },
//     { name: 'Contact Us', path: '/contact' },
//   ];

//   return (
//     <header className="w-full">
//       {/* TOP BAR - Dark Blue */}
//       <div className="bg-[#19354a] h-2 w-full fixed top-0 left-0 right-0 z-50"></div>

//       {/* MAIN NAVBAR - FIXED POSITIONING */}
//       <nav className={`fixed top-2 left-0 right-0 z-50 bg-white transition-all duration-300 ${scrolled ? 'shadow-lg' : 'shadow-sm'}`}>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
//           <div className="flex items-center justify-between h-16 md:h-20 gap-6">
            
//             {/* Logo - Left Side with more spacing */}
//             <Link to="/" className="flex items-center flex-shrink-0">
//               <img 
//                 src="/images/logo.png" 
//                 alt="Docmize Logo" 
//                 className="h-32 md:h-54 w-auto object-contain"
//               />
//             </Link>

//             {/* Desktop Nav Links - Center */}
//             <div className="hidden lg:flex items-center gap-1 xl:gap-4">
//               {navLinks.map((link) => (
//                 <div
//                   key={link.name}
//                   className="relative"
//                   onMouseEnter={() => link.hasDropdown && setServicesDropdown(true)}
//                   onMouseLeave={() => {
//                     if (link.hasDropdown) {
//                       setServicesDropdown(false);
//                       setActiveServiceCategory(null);
//                     }
//                   }}
//                 >
//                   <Link
//                     to={link.path}
//                     className={`px-3 py-2 font-medium text-sm transition-colors flex items-center gap-1 whitespace-nowrap ${
//                       location.pathname === link.path || (location.pathname.startsWith('/services') && link.hasDropdown)
//                         ? 'text-[#39a5d3]' 
//                         : 'text-gray-700 hover:text-[#39a5d3]'
//                     }`}
//                   >
//                     {link.name}
//                     {link.hasDropdown && (
//                       <svg className={`w-3 h-3 transition-transform ${servicesDropdown ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                       </svg>
//                     )}
//                   </Link>

//                   {/* Mega Menu Dropdown for Services */}
//                   {link.hasDropdown && servicesDropdown && (
//                     <div className="absolute top-full left-1/2 -translate-x-1/2 mt-0 pt-2">
//                       <motion.div
//                         initial={{ opacity: 0, y: 10 }}
//                         animate={{ opacity: 1, y: 0 }}
//                         className="bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden"
//                         style={{ width: '650px' }}
//                       >
//                         <div className="p-4 max-h-[70vh] overflow-y-auto">
//                           <div className="grid grid-cols-2 gap-3">
//                             {serviceCategories.map((category, idx) => (
//                               <div key={idx} className="border border-gray-100 rounded-lg overflow-hidden">
//                                 <div className={`flex items-center ${activeServiceCategory === idx ? 'bg-[#19354a]' : 'bg-gray-50'}`}>
//                                   <Link
//                                     to={category.path}
//                                     className={`flex-1 p-3 transition-all ${
//                                       activeServiceCategory === idx 
//                                         ? 'text-white' 
//                                         : 'text-gray-900 hover:bg-blue-50'
//                                     }`}
//                                   >
//                                     <span className="font-semibold text-sm text-left">{category.name}</span>
//                                   </Link>
//                                   <button
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       e.stopPropagation();
//                                       setActiveServiceCategory(activeServiceCategory === idx ? null : idx);
//                                     }}
//                                     className={`p-3 transition-all ${
//                                       activeServiceCategory === idx 
//                                         ? 'text-white' 
//                                         : 'text-gray-900 hover:bg-blue-50'
//                                     }`}
//                                   >
//                                     <svg 
//                                       className={`w-4 h-4 flex-shrink-0 transition-transform ${activeServiceCategory === idx ? 'rotate-180' : ''}`} 
//                                       fill="none" 
//                                       stroke="currentColor" 
//                                       viewBox="0 0 24 24"
//                                     >
//                                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                                     </svg>
//                                   </button>
//                                 </div>
                                
//                                 <AnimatePresence>
//                                   {activeServiceCategory === idx && (
//                                     <motion.div
//                                       initial={{ height: 0, opacity: 0 }}
//                                       animate={{ height: 'auto', opacity: 1 }}
//                                       exit={{ height: 0, opacity: 0 }}
//                                       transition={{ duration: 0.2 }}
//                                       className="overflow-hidden bg-white"
//                                     >
//                                       <div className="p-3 space-y-1">
//                                         {category.subServices.map((service, sIdx) => (
//                                           <div
//                                             key={sIdx}
//                                             className="flex items-start gap-2 px-2 py-1.5 rounded text-xs text-gray-600"
//                                           >
//                                             <span className="w-1 h-1 rounded-full bg-[#39a5d3] mt-1.5 flex-shrink-0"></span>
//                                             <span>{service}</span>
//                                           </div>
//                                         ))}
//                                       </div>
//                                     </motion.div>
//                                   )}
//                                 </AnimatePresence>
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       </motion.div>
//                     </div>
//                   )}
//                 </div>
//               ))}
//             </div>

//             {/* Right Side - Contact Info + CTA with more spacing */}
//             <div className="hidden lg:flex items-center gap-4 xl:gap-5 flex-shrink-0">
//               {/* Phone */}
//               <a href="tel:+918920845297" className="flex items-center gap-2.5 group">
//                 <div className="w-10 h-10 rounded-full bg-[#39a5d3] flex items-center justify-center transition-all group-hover:bg-[#19354a]">
//                   <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
//                   </svg>
//                 </div>
//                 <div className="hidden xl:block">
//                   <p className="text-[10px] font-medium text-gray-500 uppercase tracking-wide">Call us</p>
//                   <p className="text-sm font-bold text-[#19354a]">8920845297</p>
//                 </div>
//               </a>

//               {/* Email */}
//               <a href="mailto:mail@docmize.com" className="flex items-center gap-2.5 group">
//                 <div className="w-10 h-10 rounded-full bg-[#39a5d3] flex items-center justify-center transition-all group-hover:bg-[#19354a]">
//                   <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
//                   </svg>
//                 </div>
//                 <div className="hidden xl:block">
//                   <p className="text-[10px] font-medium text-gray-500 uppercase tracking-wide">Mail us</p>
//                   <p className="text-sm font-bold text-[#19354a]">mail@docmize.com</p>
//                 </div>
//               </a>

//               {/* CTA Button */}
//               <Link 
//                 to="/contact" 
//                 className="px-6 py-2.5 bg-[#19354a] text-white rounded-lg font-semibold text-sm hover:bg-[#0f2133] transition-all whitespace-nowrap shadow-md hover:shadow-lg"
//               >
//                 Get A Quote
//               </Link>
//             </div>

//             {/* Mobile Menu Button */}
//             <button
//               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//               className="lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5"
//             >
//               <motion.span
//                 animate={mobileMenuOpen ? { rotate: 45, y: 6 } : { rotate: 0, y: 0 }}
//                 className="w-6 h-0.5 block bg-[#19354a]"
//               />
//               <motion.span
//                 animate={mobileMenuOpen ? { opacity: 0 } : { opacity: 1 }}
//                 className="w-6 h-0.5 block bg-[#19354a]"
//               />
//               <motion.span
//                 animate={mobileMenuOpen ? { rotate: -45, y: -6 } : { rotate: 0, y: 0 }}
//                 className="w-6 h-0.5 block bg-[#19354a]"
//               />
//             </button>
//           </div>
//         </div>
//       </nav>

//       {/* Mobile Menu */}
//       <AnimatePresence>
//         {mobileMenuOpen && (
//           <motion.div
//             initial={{ opacity: 0, x: '100%' }}
//             animate={{ opacity: 1, x: 0 }}
//             exit={{ opacity: 0, x: '100%' }}
//             transition={{ type: 'tween', duration: 0.3 }}
//             className="fixed inset-0 z-40 lg:hidden bg-white"
//             style={{ top: '88px' }}
//           >
//             <div className="px-6 pb-6 h-full overflow-y-auto">
//               {navLinks.map((link, index) => (
//                 <motion.div
//                   key={link.name}
//                   initial={{ opacity: 0, x: 20 }}
//                   animate={{ opacity: 1, x: 0 }}
//                   transition={{ delay: index * 0.05 }}
//                   className="border-b border-gray-100"
//                 >
//                   {link.hasDropdown ? (
//                     <>
//                       <button
//                         onClick={() => setMobileServiceExpanded(mobileServiceExpanded === 'services' ? null : 'services')}
//                         className="w-full py-4 font-medium text-lg text-[#19354a] flex items-center justify-between"
//                       >
//                         {link.name}
//                         <svg 
//                           className={`w-5 h-5 transition-transform ${mobileServiceExpanded === 'services' ? 'rotate-180' : ''}`} 
//                           fill="none" 
//                           stroke="currentColor" 
//                           viewBox="0 0 24 24"
//                         >
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                         </svg>
//                       </button>
                      
//                       <AnimatePresence>
//                         {mobileServiceExpanded === 'services' && (
//                           <motion.div
//                             initial={{ height: 0, opacity: 0 }}
//                             animate={{ height: 'auto', opacity: 1 }}
//                             exit={{ height: 0, opacity: 0 }}
//                             transition={{ duration: 0.3 }}
//                             className="overflow-hidden"
//                           >
//                             <div className="pb-4">
//                               {serviceCategories.map((category, catIdx) => (
//                                 <div key={catIdx} className="mb-2">
//                                   <div className={`flex items-center rounded-lg overflow-hidden ${activeServiceCategory === catIdx ? 'bg-[#19354a]' : 'bg-gray-50'}`}>
//                                     <Link
//                                       to={category.path}
//                                       className={`flex-1 text-left px-4 py-3 transition-all ${
//                                         activeServiceCategory === catIdx 
//                                           ? 'text-white' 
//                                           : 'text-gray-700'
//                                       }`}
//                                     >
//                                       <span className="font-medium text-sm">{category.name}</span>
//                                     </Link>
//                                     <button
//                                       onClick={() => setActiveServiceCategory(activeServiceCategory === catIdx ? null : catIdx)}
//                                       className={`px-4 py-3 transition-all ${
//                                         activeServiceCategory === catIdx 
//                                           ? 'text-white' 
//                                           : 'text-gray-700'
//                                       }`}
//                                     >
//                                       <svg 
//                                         className={`w-4 h-4 transition-transform ${activeServiceCategory === catIdx ? 'rotate-180' : ''}`} 
//                                         fill="none" 
//                                         stroke="currentColor" 
//                                         viewBox="0 0 24 24"
//                                       >
//                                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                                       </svg>
//                                     </button>
//                                   </div>
                                  
//                                   <AnimatePresence>
//                                     {activeServiceCategory === catIdx && (
//                                       <motion.div
//                                         initial={{ height: 0, opacity: 0 }}
//                                         animate={{ height: 'auto', opacity: 1 }}
//                                         exit={{ height: 0, opacity: 0 }}
//                                         transition={{ duration: 0.2 }}
//                                         className="overflow-hidden"
//                                       >
//                                         <div className="pl-4 pt-2 space-y-1">
//                                           {category.subServices.map((service, sIdx) => (
//                                             <div
//                                               key={sIdx}
//                                               className="flex items-center gap-2 py-2 px-3 text-sm text-gray-600"
//                                             >
//                                               <span className="w-1.5 h-1.5 rounded-full bg-[#39a5d3]"></span>
//                                               {service}
//                                             </div>
//                                           ))}
//                                         </div>
//                                       </motion.div>
//                                     )}
//                                   </AnimatePresence>
//                                 </div>
//                               ))}
//                             </div>
//                           </motion.div>
//                         )}
//                       </AnimatePresence>
//                     </>
//                   ) : (
//                     <Link
//                       to={link.path}
//                       className="block py-4 font-medium text-lg text-[#19354a]"
//                     >
//                       {link.name}
//                     </Link>
//                   )}
//                 </motion.div>
//               ))}

//               <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: 0.4 }}
//                 className="mt-6"
//               >
//                 <Link to="/contact" className="block">
//                   <button className="w-full py-3 rounded-lg font-bold text-white bg-[#19354a]">
//                     Get A Quote
//                   </button>
//                 </Link>
//               </motion.div>

//               <div className="mt-6 space-y-3">
//                 <a href="tel:+918920845297" className="flex items-center gap-3 text-gray-700">
//                   <div className="w-10 h-10 rounded-full bg-[#39a5d3] flex items-center justify-center">
//                     <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
//                       <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
//                     </svg>
//                   </div>
//                   <span className="font-medium">+91 8920845297</span>
//                 </a>
//                 <a href="mailto:mail@docmize.com" className="flex items-center gap-3 text-gray-700">
//                   <div className="w-10 h-10 rounded-full bg-[#39a5d3] flex items-center justify-center">
//                     <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
//                       <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
//                     </svg>
//                   </div>
//                   <span className="font-medium">mail@docmize.com</span>
//                 </a>
//               </div>
//             </div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </header>
//   );
// };

// export default Navbar;


import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [servicesDropdown, setServicesDropdown] = useState(false);
  const [aboutDropdown, setAboutDropdown] = useState(false);
  const [activeServiceCategory, setActiveServiceCategory] = useState(null);
  const [mobileServiceExpanded, setMobileServiceExpanded] = useState(null);
  const [mobileAboutExpanded, setMobileAboutExpanded] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
    setServicesDropdown(false);
    setAboutDropdown(false);
    setActiveServiceCategory(null);
    setMobileAboutExpanded(false);
  }, [location]);

  const aboutLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Our Team', path: '/team' },
    { name: 'What We Do', path: '/what-we-do' },
    { name: 'Client Reviews', path: '/reviews' },
    { name: 'Hiring', path: '/hiring' },
    { name: 'Blog', path: '/blog' },
  ];

  const serviceCategories = [
    {
      name: 'Patient Growth & Visibility',
      path: '/services/growth-visibility',
      subServices: [
        'SEO for Doctors',
        'Local SEO (Clinic Area Targeting)',
        'Google My Business (GMB) Management',
        'Multi-Location Clinic SEO',
        'Medical Directory Listings',
        'Online Reputation Management',
        'Review & Rating Growth'
      ]
    },
    {
      name: 'Ads & Patient Acquisition',
      path: '/services/marketing-client-acquisition',
      subServices: [
        'Google Ads for Doctors',
        'Meta Ads (Facebook & Instagram)',
        'LinkedIn Ads (Hospitals & Groups)',
        'Patient Lead Generation',
        'Funnel & Retargeting Setup',
        'Ad Monitoring & Optimization'
      ]
    },
    {
      name: 'Social Media & Branding',
      path: '/services/social-media-branding',
      subServices: [
        'Social Media Management',
        'Content Planning & Posting',
        'Instagram, Facebook & LinkedIn',
        'Comment & DM Management',
        'Influencer & Medical Outreach',
        'Doctor Brand Building'
      ]
    },
    {
      name: 'Lead Management & Virtual Assistants',
      path: '/services/meta-virtual-assistant',
      subServices: [
        'Lead Management System',
        'CRM Setup & Automation',
        'Appointment Booking Support',
        'Patient Follow-Ups',
        'Meta Ads Virtual Assistant',
        'Customer Support Assistance'
      ]
    },
    {
      name: 'Patient Communication & Analytics',
      path: '/services/patient-communication-analytics',
      subServices: [
        'Email Marketing for Clinics',
        'WhatsApp Patient Campaigns',
        'Automated Appointment Reminders',
        'Performance Reports',
        'Conversion & ROI Analytics'
      ]
    },
    {
      name: 'Websites, Apps & Technology',
      path: '/services/digital-platforms-experience',
      subServices: [
        'Domain Purchase & Management',
        'Doctor & Clinic Website Development',
        'Website Redesign & Revamp',
        'Conversion-Focused Design',
        'Website Speed Optimization',
        'Website Security & Maintenance',
        'App Development for Clinics'
      ]
    },
    {
      name: 'Creative, Media & Content',
      path: '/services/creative-media-branding',
      subServices: [
        'Brand Identity & Logo Design',
        'Social Media Creatives',
        'Ad Creatives & Banners',
        'Video Editing',
        'Motion Graphics',
        'Pitch Decks & Brochures'
      ]
    },
    {
      name: 'Systems, Compliance & Consulting',
      path: '/services/systems-automation-consulting',
      subServices: [
        'Analytics Dashboards',
        'CRM & Marketing Automation',
        'Backup & Data Protection',
        'Compliance & Website Security',
        'Clinic Growth Consulting',
        'Digital Strategy Consulting'
      ]
    }
  ];

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Company', path: '/about', hasDropdown: true, dropdownType: 'about' },
    { name: 'Services', path: '/services', hasDropdown: true, dropdownType: 'services' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Contact Us', path: '/contact' },
  ];

  return (
    <header className="w-full">
      {/* TOP BAR - Dark Blue */}
      <div className="bg-[#19354a] h-2 w-full fixed top-0 left-0 right-0 z-50"></div>

      {/* MAIN NAVBAR - FIXED POSITIONING */}
      <nav className={`fixed top-2 left-0 right-0 z-50 bg-white transition-all duration-300 ${scrolled ? 'shadow-lg' : 'shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
          <div className="flex items-center justify-between h-16 md:h-20 gap-6">
            
            {/* Logo - Left Side with more spacing */}
            <Link to="/" className="flex items-center flex-shrink-0">
              <img 
                src="/images/logo.png" 
                alt="Docmize Logo" 
                className="h-32 md:h-54 w-auto object-contain"
              />
            </Link>

            {/* Desktop Nav Links - Center */}
            <div className="hidden lg:flex items-center gap-1 xl:gap-4">
              {navLinks.map((link) => (
                <div
                  key={link.name}
                  className="relative"
                  onMouseEnter={() => {
                    if (link.dropdownType === 'services') setServicesDropdown(true);
                    if (link.dropdownType === 'about') setAboutDropdown(true);
                  }}
                  onMouseLeave={() => {
                    if (link.dropdownType === 'services') {
                      setServicesDropdown(false);
                      setActiveServiceCategory(null);
                    }
                    if (link.dropdownType === 'about') setAboutDropdown(false);
                  }}
                >
                  <Link
                    to={link.path}
                    className={`px-3 py-2 font-medium text-sm transition-colors flex items-center gap-1 whitespace-nowrap ${
                      location.pathname === link.path || 
                      (location.pathname.startsWith('/services') && link.dropdownType === 'services') ||
                      (location.pathname.startsWith('/about') && link.dropdownType === 'about') ||
                      (link.dropdownType === 'about' && aboutLinks.some(al => location.pathname === al.path))
                        ? 'text-[#39a5d3]' 
                        : 'text-gray-700 hover:text-[#39a5d3]'
                    }`}
                  >
                    {link.name}
                    {link.hasDropdown && (
                      <svg className={`w-3 h-3 transition-transform ${
                        (link.dropdownType === 'services' && servicesDropdown) || 
                        (link.dropdownType === 'about' && aboutDropdown) ? 'rotate-180' : ''
                      }`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                      </svg>
                    )}
                  </Link>

                  {/* About Us Dropdown */}
                  {link.dropdownType === 'about' && aboutDropdown && (
                    <div className="absolute top-full left-1/2 -translate-x-1/2 mt-0 pt-2">
                      <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden"
                        style={{ width: '220px' }}
                      >
                        <div className="py-2">
                          {aboutLinks.map((aboutLink, idx) => (
                            <Link
                              key={idx}
                              to={aboutLink.path}
                              className={`block px-4 py-2.5 text-sm transition-colors ${
                                location.pathname === aboutLink.path
                                  ? 'bg-[#19354a] text-white'
                                  : 'text-gray-700 hover:bg-blue-50'
                              }`}
                            >
                              {aboutLink.name}
                            </Link>
                          ))}
                        </div>
                      </motion.div>
                    </div>
                  )}

                  {/* Mega Menu Dropdown for Services */}
                  {link.dropdownType === 'services' && servicesDropdown && (
                    <div className="absolute top-full left-1/2 -translate-x-1/2 mt-0 pt-2">
                      <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="bg-white rounded-xl shadow-2xl border border-gray-100 overflow-hidden"
                        style={{ width: '650px' }}
                      >
                        <div className="p-4 max-h-[70vh] overflow-y-auto">
                          <div className="grid grid-cols-2 gap-3">
                            {serviceCategories.map((category, idx) => (
                              <div key={idx} className="border border-gray-100 rounded-lg overflow-hidden">
                                <div className={`flex items-center ${activeServiceCategory === idx ? 'bg-[#19354a]' : 'bg-gray-50'}`}>
                                  <Link
                                    to={category.path}
                                    className={`flex-1 p-3 transition-all ${
                                      activeServiceCategory === idx 
                                        ? 'text-white' 
                                        : 'text-gray-900 hover:bg-blue-50'
                                    }`}
                                  >
                                    <span className="font-semibold text-sm text-left">{category.name}</span>
                                  </Link>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setActiveServiceCategory(activeServiceCategory === idx ? null : idx);
                                    }}
                                    className={`p-3 transition-all ${
                                      activeServiceCategory === idx 
                                        ? 'text-white' 
                                        : 'text-gray-900 hover:bg-blue-50'
                                    }`}
                                  >
                                    <svg 
                                      className={`w-4 h-4 flex-shrink-0 transition-transform ${activeServiceCategory === idx ? 'rotate-180' : ''}`} 
                                      fill="none" 
                                      stroke="currentColor" 
                                      viewBox="0 0 24 24"
                                    >
                                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                    </svg>
                                  </button>
                                </div>
                                
                                <AnimatePresence>
                                  {activeServiceCategory === idx && (
                                    <motion.div
                                      initial={{ height: 0, opacity: 0 }}
                                      animate={{ height: 'auto', opacity: 1 }}
                                      exit={{ height: 0, opacity: 0 }}
                                      transition={{ duration: 0.2 }}
                                      className="overflow-hidden bg-white"
                                    >
                                      <div className="p-3 space-y-1">
                                        {category.subServices.map((service, sIdx) => (
                                          <div
                                            key={sIdx}
                                            className="flex items-start gap-2 px-2 py-1.5 rounded text-xs text-gray-600"
                                          >
                                            <span className="w-1 h-1 rounded-full bg-[#39a5d3] mt-1.5 flex-shrink-0"></span>
                                            <span>{service}</span>
                                          </div>
                                        ))}
                                      </div>
                                    </motion.div>
                                  )}
                                </AnimatePresence>
                              </div>
                            ))}
                          </div>
                        </div>
                      </motion.div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Right Side - Contact Info + CTA with more spacing */}
            <div className="hidden lg:flex items-center gap-4 xl:gap-5 flex-shrink-0">
              {/* Phone */}
              <a href="tel:+918920845297" className="flex items-center gap-2.5 group">
                <div className="w-10 h-10 rounded-full bg-[#39a5d3] flex items-center justify-center transition-all group-hover:bg-[#19354a]">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                  </svg>
                </div>
                <div className="hidden xl:block">
                  <p className="text-[10px] font-medium text-gray-500 uppercase tracking-wide">Call us</p>
                  <p className="text-sm font-bold text-[#19354a]">8920845297</p>
                </div>
              </a>

              {/* Email */}
              <a href="mailto:mail@docmize.com" className="flex items-center gap-2.5 group">
                <div className="w-10 h-10 rounded-full bg-[#39a5d3] flex items-center justify-center transition-all group-hover:bg-[#19354a]">
                  <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                  </svg>
                </div>
                <div className="hidden xl:block">
                  <p className="text-[10px] font-medium text-gray-500 uppercase tracking-wide">Mail us</p>
                  <p className="text-sm font-bold text-[#19354a]">mail@docmize.com</p>
                </div>
              </a>

              {/* CTA Button */}
              <Link 
                to="/contact" 
                className="px-6 py-2.5 bg-[#19354a] text-white rounded-lg font-semibold text-sm hover:bg-[#0f2133] transition-all whitespace-nowrap shadow-md hover:shadow-lg"
              >
                Get A Quote
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5"
            >
              <motion.span
                animate={mobileMenuOpen ? { rotate: 45, y: 6 } : { rotate: 0, y: 0 }}
                className="w-6 h-0.5 block bg-[#19354a]"
              />
              <motion.span
                animate={mobileMenuOpen ? { opacity: 0 } : { opacity: 1 }}
                className="w-6 h-0.5 block bg-[#19354a]"
              />
              <motion.span
                animate={mobileMenuOpen ? { rotate: -45, y: -6 } : { rotate: 0, y: 0 }}
                className="w-6 h-0.5 block bg-[#19354a]"
              />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, x: '100%' }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: '100%' }}
            transition={{ type: 'tween', duration: 0.3 }}
            className="fixed inset-0 z-40 lg:hidden bg-white"
            style={{ top: '88px' }}
          >
            <div className="px-6 pb-6 h-full overflow-y-auto">
              {navLinks.map((link, index) => (
                <motion.div
                  key={link.name}
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.05 }}
                  className="border-b border-gray-100"
                >
                  {link.hasDropdown ? (
                    <>
                      <button
                        onClick={() => {
                          if (link.dropdownType === 'services') {
                            setMobileServiceExpanded(mobileServiceExpanded === 'services' ? null : 'services');
                          }
                          if (link.dropdownType === 'about') {
                            setMobileAboutExpanded(!mobileAboutExpanded);
                          }
                        }}
                        className="w-full py-4 font-medium text-lg text-[#19354a] flex items-center justify-between"
                      >
                        {link.name}
                        <svg 
                          className={`w-5 h-5 transition-transform ${
                            (link.dropdownType === 'services' && mobileServiceExpanded === 'services') || 
                            (link.dropdownType === 'about' && mobileAboutExpanded) ? 'rotate-180' : ''
                          }`} 
                          fill="none" 
                          stroke="currentColor" 
                          viewBox="0 0 24 24"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      
                      {/* About Us Mobile Dropdown */}
                      {link.dropdownType === 'about' && (
                        <AnimatePresence>
                          {mobileAboutExpanded && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: 'auto', opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3 }}
                              className="overflow-hidden"
                            >
                              <div className="pb-4">
                                {aboutLinks.map((aboutLink, idx) => (
                                  <Link
                                    key={idx}
                                    to={aboutLink.path}
                                    className={`block px-4 py-3 text-sm rounded-lg mb-1 transition-all ${
                                      location.pathname === aboutLink.path
                                        ? 'bg-[#19354a] text-white'
                                        : 'bg-gray-50 text-gray-700'
                                    }`}
                                  >
                                    {aboutLink.name}
                                  </Link>
                                ))}
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      )}

                      {/* Services Mobile Dropdown */}
                      {link.dropdownType === 'services' && (
                        <AnimatePresence>
                          {mobileServiceExpanded === 'services' && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: 'auto', opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              transition={{ duration: 0.3 }}
                              className="overflow-hidden"
                            >
                              <div className="pb-4">
                                {serviceCategories.map((category, catIdx) => (
                                  <div key={catIdx} className="mb-2">
                                    <div className={`flex items-center rounded-lg overflow-hidden ${activeServiceCategory === catIdx ? 'bg-[#19354a]' : 'bg-gray-50'}`}>
                                      <Link
                                        to={category.path}
                                        className={`flex-1 text-left px-4 py-3 transition-all ${
                                          activeServiceCategory === catIdx 
                                            ? 'text-white' 
                                            : 'text-gray-700'
                                        }`}
                                      >
                                        <span className="font-medium text-sm">{category.name}</span>
                                      </Link>
                                      <button
                                        onClick={() => setActiveServiceCategory(activeServiceCategory === catIdx ? null : catIdx)}
                                        className={`px-4 py-3 transition-all ${
                                          activeServiceCategory === catIdx 
                                            ? 'text-white' 
                                            : 'text-gray-700'
                                        }`}
                                      >
                                        <svg 
                                          className={`w-4 h-4 transition-transform ${activeServiceCategory === catIdx ? 'rotate-180' : ''}`} 
                                          fill="none" 
                                          stroke="currentColor" 
                                          viewBox="0 0 24 24"
                                        >
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                                        </svg>
                                      </button>
                                    </div>
                                    
                                    <AnimatePresence>
                                      {activeServiceCategory === catIdx && (
                                        <motion.div
                                          initial={{ height: 0, opacity: 0 }}
                                          animate={{ height: 'auto', opacity: 1 }}
                                          exit={{ height: 0, opacity: 0 }}
                                          transition={{ duration: 0.2 }}
                                          className="overflow-hidden"
                                        >
                                          <div className="pl-4 pt-2 space-y-1">
                                            {category.subServices.map((service, sIdx) => (
                                              <div
                                                key={sIdx}
                                                className="flex items-center gap-2 py-2 px-3 text-sm text-gray-600"
                                              >
                                                <span className="w-1.5 h-1.5 rounded-full bg-[#39a5d3]"></span>
                                                {service}
                                              </div>
                                            ))}
                                          </div>
                                        </motion.div>
                                      )}
                                    </AnimatePresence>
                                  </div>
                                ))}
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      )}
                    </>
                  ) : (
                    <Link
                      to={link.path}
                      className="block py-4 font-medium text-lg text-[#19354a]"
                    >
                      {link.name}
                    </Link>
                  )}
                </motion.div>
              ))}

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="mt-6"
              >
                <Link to="/contact" className="block">
                  <button className="w-full py-3 rounded-lg font-bold text-white bg-[#19354a]">
                    Get A Quote
                  </button>
                </Link>
              </motion.div>

              <div className="mt-6 space-y-3">
                <a href="tel:+918920845297" className="flex items-center gap-3 text-gray-700">
                  <div className="w-10 h-10 rounded-full bg-[#39a5d3] flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                    </svg>
                  </div>
                  <span className="font-medium">+91 8920845297</span>
                </a>
                <a href="mailto:mail@docmize.com" className="flex items-center gap-3 text-gray-700">
                  <div className="w-10 h-10 rounded-full bg-[#39a5d3] flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                  </div>
                  <span className="font-medium">mail@docmize.com</span>
                </a>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;